import React, { useEffect, useState } from 'react';
import {
  Card,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core';
import PeopleIcon from '@material-ui/icons/AccountCircle';
import CardTitle from '../../../common/card/CardTitle';
import { Product } from '../Product.interface';
import { User } from '../../../user/User.interface';
import AssignPeopleDialog from '../dialogs/AssignPeopleDialog';
import { useFindProduct } from '../Product.hooks';
import { useTaskEntityFields } from '../../workflow/Workflow.hooks';

const ProductPeopleCard: React.FC<{ product: Product }> = ({
  product: initProduct
}) => {
  const id = initProduct.id;
  const { product: result, findProduct } = useFindProduct(id);
  const [product, setProduct] = useState<Product>(initProduct);
  const { productOwner, techLead } = product;
  const [assignedUser, setAssignedUser] = useState<User | undefined>();
  const [role, setRole] = useState<'Product Owner' | 'Tech Lead' | undefined>();

  useEffect(() => {
    result && setProduct(result);
  }, [result]);

  const assignProductOwner = (user: User | undefined) => {
    setAssignedUser(user);
    setRole('Product Owner');
  };

  const assignTechLead = (user: User | undefined) => {
    setAssignedUser(user);
    setRole('Tech Lead');
  };
  const { isFieldDisabled } = useTaskEntityFields(product.task);
  return (
    <Card>
      <CardTitle>
        <PeopleIcon />
        People
      </CardTitle>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Role</TableCell>
              <TableCell>Name</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow
              hover={!isFieldDisabled('productOwner')}
              onClick={() => {
                if (!isFieldDisabled('productOwner')) {
                  assignProductOwner(productOwner);
                }
              }}
            >
              <TableCell>Product Owner</TableCell>
              <TableCell>
                {productOwner ? (
                  `${productOwner?.firstName} ${productOwner?.lastName}`
                ) : isFieldDisabled('productOwner') ? (
                  'not assigned'
                ) : (
                  <Link
                    component='button'
                    variant='body2'
                    disabled={isFieldDisabled('productOwner')}
                    onClick={() => assignProductOwner(undefined)}
                  >
                    Assign
                  </Link>
                )}
              </TableCell>
            </TableRow>
            <TableRow
              hover={!isFieldDisabled('techLead')}
              onClick={() => {
                if (!isFieldDisabled('techLead')) {
                  assignTechLead(techLead);
                }
              }}
            >
              <TableCell>Tech Lead</TableCell>
              <TableCell>
                {techLead ? (
                  `${techLead?.firstName} ${techLead?.lastName}`
                ) : isFieldDisabled('techLead') ? (
                  'not assigned'
                ) : (
                  <Link
                    component='button'
                    variant='body2'
                    onClick={() => assignTechLead(undefined)}
                  >
                    Assign
                  </Link>
                )}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      {role && (
        <AssignPeopleDialog
          open={Boolean(role)}
          productId={id}
          assignedUser={assignedUser}
          role={role}
          onCancel={() => setRole(undefined)}
          onAssigned={() => {
            setRole(undefined);
            findProduct();
          }}
        />
      )}
    </Card>
  );
};

export default ProductPeopleCard;
